import { Table } from "antd";
import React, { useCallback, useState } from "react";

export default function CustomTable({ data, columns,...props }) {
	console.log(data)
	const [currentPage, setCurrentPage] = useState(1);
	const PAGE_SIZE = 12; // Number of products per page
	const handlePageChange = useCallback((page) => setCurrentPage(page), []);
	return (
		<Table
			columns={columns}
			dataSource={data}
			loading={data?.length > -1 ? false : true}
			pagination={{
				current: currentPage,
				pageSize: PAGE_SIZE,
				total: data?.length,
				onChange: handlePageChange,
			}}
			{...props}
		/>
	);
}
